module.exports = __webpack_public_path__ + "img/logo-villa-mobile.349b5202.svg";